$(document).ready(function () {
    sethtmlData();
});

function sethtmlData() {
    $.ajax({
        url: "header_last.html",
        async: true,
        success: function (data) {
            $('.header_content').html(data);
        }
    });
    $.ajax({
        url: "footer.html",
        async: true,
        success: function (data) {
            $('.footer_content').html(data);
        }
    });
    $.ajax({
        url: "settings.json",
        async: true,
        success: function (data) {
            $('#header-logo').html(data.region);
            if (data.hasTurn) {
                $('#header_Turn').show();
                $('#base_Turn').hide();
                $('#base_hasTurn').show();
                $('#footer_turn').show();

                $('.navbar_block__collapse_menu').css('margin-left', '0em');
                $('.navbar_block__collapse_menu').css('font-size', '1.18em');
            }
            else {
                $('#header_Turn').hide();
                $('#base_hasTurn').hide();
                $('#base_Turn').show();
                $('#footer_turn').hide();
                $('.navbar_block__collapse_menu').css('margin-left', '3.6em');
                $('.navbar_block__collapse_menu').css('font-size', '1.25em');
            }
        },
        error: function () {
            alert('Не найден файл (settings.json) с наименованием региона');
        }
    });

}
export function getCoord() {
    var b = [];
    $.ajax({
        url: "settings.json",
        async: false,
        success: function (data) {
            b = data.coord.replace(' ', '').trim().split(',');
        },
        error: function () {
            b = ['55.75797', '37.622246']// Москва;
        }
    });
    return b;
}

export function getApiKey() {
    var b = '';
    $.ajax({
        url: "settings.json",
        async: false,
        success: function (data) {
            b = data.key;
        },
        error: function () {
            b = "3be8ed6e-81c7-4bb4-a491-b76817970a74"; // челябинский ключ
        }
    });
    return b;
}

///////////////////////////////// методы обмена данными /////////////////////////////////

//парсит параметры с формы ввода в обьект
// inputs: formCaption - id формы без #
// outputs: [{name: "key", value: "text:param"},
//          {name: "key", value: "param"}]
function formToObj(formCaption) {
    const arr = ['select', 'input'];
    var rezArr = [];

    for (var i = 0; i < arr.length; i++) {
        var $objArr = $('#' + formCaption).find(arr[i]);
        for (var j = 0; j < $objArr.length; j++) {
            var $item = $($objArr[j]);
            if ($item.attr('name') !== undefined) {
                var rezObj = {};
                let value = checkVal($item);
                if (typeof (value) === 'object') {
                    value.forEach(function (item) {
                        rezArr.push(item);
                    })
                }
                else {
                    if (checkVal($item) !== "") {
                        rezObj.name = $item.attr('name');
                        rezObj.value = checkVal($item);

                        rezArr.push(rezObj);
                    }
                }
            }
        }
    }
    return rezArr;
    function checkVal($item) {
        let value = $item.val();

        if (value) {

            switch ($item.prop('tagName')) {
                case 'INPUT':
                    if ($item.attr('type') === 'checkbox') {
                        if ($item.prop("checked"))
                            return 'on';
                        else return '';
                    }
                    else return value;
                    break;
                case 'SELECT':
                    let arr = [];
                    let obj = $('#' + $item.attr('id') + ' option:selected');
                    for (let i = 0; i < obj.length; i++) {
                        let item = obj[i];
                        let rez = {};
                        rez.name = $item.attr('name');
                        rez.value = item.text + ':' + item.value;
                        arr.push(rez);
                    }
                    return arr
                    break;
            }
        }
        else
            return '';
    }
}

// выделяет обьекты с множественным выбором 
// outputs {key:["param", "param"]}
function setDataMulticontrol(iArr, rezObj) {
    let iArrKey = Object.keys(rezObj);
    let data = {};
    $.each(iArrKey, (indexKey, valueKey) => {
        var TArr = [];
        $.each(iArr, (index, val) => {
            let name = val.name;
            if (name.indexOf(valueKey) > -1) {
                let Tval = val.value;
                TArr.push(Tval);
            }
        })
        if (TArr.length > 1)
            data[valueKey] = TArr;

    })
    return data;
}

// перевод параметров с формы в url
export function dataFormToURL(formСaption) {
    var localName = location.pathname.split('/');
    if (localName.length > 1)
        localName.splice(0, localName.length - 1);

    var rezStrSt = localName + '?';

    var rezStr = '';
    var formParam = formToObj(formСaption);

    let sentObj = {};
    $.each(formParam, (index, val) => {
        let vl = val.value;
        sentObj[val.name] = vl;
    })
    sentObj["PageSize"] = "10";
    sentObj["Sort"] = "0";

    let multiData = setDataMulticontrol(formParam, sentObj);

    $.each(sentObj, (key, value) => {
        sentObj[key] = (multiData[key] === undefined ? sentObj[key] : multiData[key]);
    })

    $.each(sentObj, (key, val) => {
        rezStr += '&' + key + '=' + arrToStr(val);
    })
    history.pushState('', document.title, rezStrSt + rezStr.substr(1));
}

function arrToStr(arr) {
    let str = '';
    if (typeof (arr) === 'object') {
        arr.forEach((value, index, arr) => {
            str += ';' + value;
        })
        return str.substr(1);
    }
    else return arr;

}

// перевод параметров url в обьект для отправки на сервер или для заполнения контролов
//cntrl = false для ajax
//cntrl = true для заполнения конролов
export function urlToObj(cntrl) {
    let url = decodeURIComponent(location.search);
    var queryStart = url.indexOf("?") + 1,
        queryEnd = url.indexOf("#") + 1 || url.length + 1,
        query = url.slice(queryStart, queryEnd - 1),
        data = {},
        nv,
        k,
        v,
        pairs = query.replace(/\+/g, " ").split("&");
    if (query === url || query === "") {
        return data = null;
    }
    for (let i = 0; i < pairs.length; i++) {
        nv = pairs[i].split("=");
        k = decodeURIComponent(nv[0]);
        v = decodeURIComponent(nv[1]) === "on" ? true : decodeURIComponent(nv[1]);
        if (v !== "" && v !== undefined) {
            let tv = parseUrlToArr(v, cntrl);
            data[k] = tv;
        }
    }
    return data;
}

function parseUrlToArr(iStr, cntrl) {
    let Tarr = iStr.split(';');
    let Rarr = [];
    if (Tarr.length > 1) {
        Tarr.forEach((value, index, Tarr) => {
            if (!cntrl)
                Rarr[index] = value.split(':')[1];
            else {
                let Tobj = {};
                Tobj.k = value.split(':')[1];
                Tobj.v = value.split(':')[0];
                Rarr[index] = Tobj;
            }

        })
        return Rarr;
    }
    else {
        let Tval = Tarr[0];
        if (Tval.split(':').length > 1) {
            if (!cntrl)
                return Tval.split(':')[1];
            else {
                let Tobj = {};
                Tobj.k = Tval.split(':')[1];
                Tobj.v = Tval.split(':')[0];
                return Tobj;
            }
        }
        else
            return Tval;
    }
}

///////////////////////////////// Грид /////////////////////////////////
export function SetValuePSize(id) {
    $('.page-count-rows__btn-info').text(id);
    changeGridControls(null);
}

export function SetValuePsort(id) {
    var txt = $('#' + id).text();
    $('.page-sort-rows__btn-info').text(txt);
    $('.page-sort-rows__input-value').val(id[0]);
    changeGridControls(null);
}

//заполнение компонентов поиска из url
export function setParamTo(data) {
    for (var item in data)
        switch (item) {
            case 'PageSize':
                $('.page-count-rows__btn-info').text(data[item]);
                break;
            case 'Sort':
                $('.page - sort - rows__input - value').val(data[item]);
                var txt = $('#' + data[item] + '_sd').text();
                $('.page-sort-rows__btn-info').text(txt);
                break;
            default:
                $('input[name="' + item + '"]').val(data[item]);
                break;

        }
}


//изменение параметров поиска данных из url
function setSearchParam(arrObj) {
    var searchstr = location.search.split('&');
    searchstr[0] = searchstr[0].substr(1);
    var rezult = '';
    for (var j = 0; j < arrObj.length; ++j) {
        var item = arrObj[j];
        for (var i = 0; i < searchstr.length; ++i)
            if (searchstr[i].search(item.k) === 0)
                searchstr[i] = "";
    }
    for (var i = 0; i < searchstr.length; ++i)
        if (searchstr[i] !== "")
            rezult += '&' + searchstr[i];
    for (var j = 0; j < arrObj.length; ++j) {
        var item = arrObj[j];
        rezult += '&' + item.k + '=' + item.v;
    }
    rezult = '?' + rezult.substr(1);
    return rezult;
}

///////////////////////////////// Анимация /////////////////////////////////

// - функция запуска анимации
export function startLoadingAnimation() {
    var imgObj = $("#loadImg");
    imgObj.show();

    var centerY = $(window).scrollTop() + $(window).height() / 2;
    var centerX = $(window).scrollLeft() + ($(window).width()) / 2;
    imgObj.offset({ top: centerY, left: centerX });
}

// - функция остановки анимации
export function stoptLoadingAnimation() {
    $("#loadImg").hide();
}

///////////////////////////////// Контролы /////////////////////////////////
// param - параметр запроса
function setDataControl(lookupTable, param) {
    var data = {};
    if (lookupTable !== null && lookupTable !== '') {
        data.lookupTable = lookupTable;
    }
    data.name = param;
    return JSON.stringify(data);
}

function setAjaxRequest(term, object, dataToJSON) {
    $.ajax({
        type: "Post",
        url: "./ASPWebDataServise.asmx/GetLookupTable",
        data: "{inputsParam:'" + dataToJSON + "'}",
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function (response) {
            var data = JSON.parse(response.d);
            var $items = [];
            $.each(data, function (k, v) {
                let Obj = {
                    k: v.k,
                    v: replaceBrackets(v.v)
                }
                $items.push(Obj);
            });
            object.trigger('tokenize:dropdown:fill', [$items]);
        }
    });
}

//инициализация контролов 
export function setControlforReestrListform() {
    $('#formobsl').mSelect({
        tokensMaxItems: 1,
        placeholder: 'начните ввод...',
        dataSource: function (term, object) {
            setAjaxRequest(term, object, setDataControl('formobsl', term))
        }
    });

    $('#s_uslug').mSelect({
        placeholder: 'начните ввод...',
        dataSource: function (term, object) {
            setAjaxRequest(term, object, setDataControl('s_uslug', term))
        }
    });
    $('#s_gn').mSelect({
        placeholder: 'начните ввод...',
        dataSource: function (term, object) {
            setAjaxRequest(term, object, setDataControl('s_gn', term))
        }
    });
    $('#reg_id').mSelect({
        placeholder: 'начните ввод...',
        dataSource: function (term, object) {
            setAjaxRequest(term, object, setDataControl('reg_id', term))
        }
    });
    $('#s_viduchobsl').mSelect({
        placeholder: 'начните ввод...',
        dataSource: function (term, object) {
            setAjaxRequest(term, object, setDataControl('s_viduchobsl', term))
        }
    });
    $('#s_tipuchobsl').mSelect({
        placeholder: 'начните ввод...',
        dataSource: function (term, object) {
            setAjaxRequest(term, object, setDataControl('s_tipuchobsl', term))
        }
    });
}

export function setVaribleElemToCntrl(formCaption, setObj) {
    for (let iemObj in setObj) {
        if (typeof (setObj[iemObj]) === 'object') {

            let key = null;
            let value = null;

            var arrObjtoCntrl = setObj[iemObj];

            if ("length" in arrObjtoCntrl) {
                for (let data in arrObjtoCntrl) {
                    if (arrObjtoCntrl[data]) {
                        key = (arrObjtoCntrl[data].k ? arrObjtoCntrl[data].k : arrObjtoCntrl[data].id);
                        value = (arrObjtoCntrl[data].v ? arrObjtoCntrl[data].v : arrObjtoCntrl[data].name);

                        if ($('#' + formCaption).find('[name = ' + iemObj + ']').length > 0)
                            $('#' + formCaption).find('[name = ' + iemObj + ']').mSelect().trigger('tokenize:tokens:add', [key, value, true]);
                        else
                            if ($('#' + formCaption).find('#' + iemObj).length > 0)
                                $('#' + formCaption).find('#' + iemObj).mSelect().trigger('tokenize:tokens:add', [key, value, true]);
                    }
                }
            }
            else {
                let key = arrObjtoCntrl.k;
                let value = arrObjtoCntrl.v;

                if ($('#' + formCaption).find('[name = ' + iemObj + ']').length > 0)
                    $('#' + formCaption).find('[name = ' + iemObj + ']').mSelect().trigger('tokenize:tokens:add', [key, value, true]);
                else
                    if ($('#' + formCaption).find('#' + iemObj).length > 0)
                        $('#' + formCaption).find('#' + iemObj).mSelect().trigger('tokenize:tokens:add', [key, value, true]);
            }
        }
        else {
            $('#' + formCaption).find('[name = ' + iemObj + ']').val(setObj[iemObj]);
        }
    }
}

//очистка панели поиска 
export function clear(formCaption) {
    let $arr = $('#' + formCaption).find('select');
    $arr.each((index, element) => {
        let id = element.id;
        $('#' + formCaption).find('#' + id).mSelect().trigger('tokenize:clear');
    })

    $('#' + formCaption).find('input').val('');
}



///////////////////////////////// AJAX /////////////////////////////////
// inputs: captionFunc - заголовок функции к которой обращаемся
//         sendObj - обьект который передаем(без JSON)
export function sentAjaxTo(captionFunc, sendObj) {
    var idVidUsl = null;
    try {
        idVidUsl = sendObj.idVidUsl;
    } catch (e) { }
    let sendJSON = JSON.stringify(sendObj);
    if (captionFunc !== 'SetNumUpDownStateRating') startLoadingAnimation();
    $.ajax({
        type: "Post",
        url: "./ASPWebDataServise.asmx/" + captionFunc,
        data: "{inputsParam:'" + sendJSON + "'}",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
            let resp = JSON.parse(response.d)
            switch (captionFunc) {

                case 'GetListOrg':
                    var reestr = require('./reestr_new.js');
                    reestr.setDataListOrg(resp);
                    break;
                case 'GetBasicInfo':
                    var org = require('./org_last.js');
                    org.setBasicInform(resp);
                    break;
                case 'GetStructUnitsInfo':
                    var org = require('./org_last.js');
                    org.setStructInfo(resp);
                    break;
                case 'GetFormsInfo':
                    var org = require('./org_last.js');
                    org.setFormsInfo(resp);
                    break;
                case 'GetLicenseInfo':
                    var org = require('./org_last.js');
                    org.setLicenseInfo(resp);
                    break;
                case 'GetFreePlaceInfo':
                    var org = require('./org_last.js');
                    org.setFreePlaseInfo(resp);
                    break;
                case 'GetVerificationInfo':
                    var org = require('./org_last.js');
                    org.setVereficationInfo(resp);
                    break;
                case 'GetViolationsInfo':
                    var org = require('./org_last.js');
                    org.setViolationsInfo(resp);
                    break;
                case 'GetWorkInfo':
                    var org = require('./org_last.js');
                    org.setWorkInfo(resp);
                    break;
                case 'GetAddrList':
                    var maps = require('./maps_last.js');
                    maps.setAddrList(resp);
                    break;
                case 'GetListVidOrgForMaps':
                    var maps = require('./maps_last.js');
                    maps.setListVidOrgForMaps(resp);
                    break;
                case 'GetInfoListMaps':
                    var maps = require('./maps_last.js');
                    maps.setListOrgForMaps(resp);
                    break;
                case 'GetTarifInfo':
                    var org = require('./org_last.js');
                    org.setTarifInfo(resp);
                    break;
                case 'GetDataforSelector':
                    var org = require('./org_last.js');
                    if (idVidUsl === undefined)
                        org.setFormsObslCntrl(resp);
                    else
                        org.setVidUslCntrl(resp);
                    break;
                case 'GetOtherInfo':
                    var org = require('./org_last.js');
                    org.setOtherInfo(resp);
                    break;
                case 'GetGaleryInfo':
                    var org = require('./org_last.js');
                    if (resp != '') {
                        if (!resp[0].hasOwnProperty('photo'))
                            org.setPictInfo(resp);
                        else
                            org.setSinglePick(resp);
                    }
                    else {
                        $('.pick_container').show();
                        $('.pick_container').html('<p style= "width:100%; text-align:center; padding: 1rem" > К сожалению нет информации </p>');
                    }
                    break;
                case 'GetOrgRating':
                    var org = require('./org_last.js');
                    org.setRPostRating(resp);
                    break;
                case 'SetOrgRating':
                    var org = require('./org_last.js');
                    org.setRPostRatingData(resp);
                    break;
                case 'SetNumUpDownStateRating':
                    var org = require('./org_last.js');
                    org.setStateRating(resp);
                    break;
                case 'GetListVidUsl':
                    var index = require('./index_last.js');
                    index.setListVidUsl(resp);
                    break;
                case 'GetListUslFromVidUsl':
                    var index = require('./index_last.js');
                    index.setListUslFromVidUsl(resp);
                    break;
                case 'GetListOrgFromUsl':
                    var usluga = require('./usluga_new.js');
                    usluga.setListOrgFromUsl(resp);
                    break;
                case 'GetQuestions':
                    var org = require('./org_last.js');
                    org.setQuestionList(resp);
                    break;
                case 'GetOrgMerop':
                    var org = require('./org_last.js');
                    org.setOrgMerop(resp);
                    break;
                case 'GetUslPred':
                    var org = require('./org_last.js');
                    org.setUslPred(resp);
                    break;
                case 'GetTurn':
                    var turn = require('./turn.js');
                    turn.setResult(resp);
                    break;
                case 'GetCaptionGroupОfАctivities':
                    var org = require('./org_last.js');
                    org.setCaptionGroupОfАctivities(resp);
                    break;
            }
            if (captionFunc !== 'GetDataforSelector') stoptLoadingAnimation();
        },
        error: function (response) {
            stoptLoadingAnimation();
        }
    });

}

// возвращает cookie с именем name, если есть, если нет, то undefined
export function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function setCookie(name, value, options) {
    options = options || {};
    var expires = options.expires;
    if (typeof expires === "number" && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
    }
    value = encodeURIComponent(value);
    var updatedCookie = name + "=" + value;
    for (var propName in options) {
        updatedCookie += "; " + propName;
        var propValue = options[propName];
        if (propValue !== true) {
            updatedCookie += "=" + propValue;
        }
    }
    document.cookie = updatedCookie;
}

function deleteCookie(name) {
    setCookie(name, "", {
        expires: -1
    })
}


///////////////////////////////// прочие методы /////////////////////////////////

//обрезание скобок вначале строки
export function replaceBrackets(str) {
    let end = str.indexOf(')') + 1;
    let lenth_ = str.length;

    let rezult = str;
    if (end !== -1)
        rezult = str.slice(end, lenth_);
    return rezult;
}

//обрезание скобок для строки которая разделена символом
export function replaceBracketsArr(str, ch) {
    let arr_ = str.split(ch);
    let rezult = '';
    arr_.forEach((value, inde, arr_) => {
        rezult += (ch + ' ' + replaceBrackets(value));
    })
    return rezult.substr(1);
}
